import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import { userService } from "../helpers/fakebackend/user.service";
import store from "@/state/store";

// import store from "@/state/store";
import routes from "./routes";

Vue.use(VueRouter);
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: "page",
});

const router = new VueRouter({
  routes,
  // Hash mode works on static production hosting without server rewrite rules.
  mode: "hash",
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {
  // auth kontrolü

  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

  if (!authRequired) return next();

  store.dispatch("layout/changeLoaderValue", { loader: true });

  let loggedIn = false;
  let tokenValid = false;
  let userString = localStorage.getItem("user");
  let user = JSON.parse(userString);

  if (user) {
    loggedIn = true;
    if (user.token) {
      await userService.validateToken(user.token).then((res) => {
        if (res.status === 200) {
          tokenValid = true;
          store.dispatch("layout/changeLoaderValue", { loader: false });
          localStorage.setItem("credit", res.credit);
        }
      });
    }
  }

  if (!loggedIn || !tokenValid) {
    store.dispatch("layout/changeLoaderValue", { loader: false });
    return next("/login");
  }

  next();
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          // Otherwise, continue resolving the route.
          resolve();
        }
      });
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return;
  }

  // If we reach this point, continue resolving the route.
  next();
});

export default router;
